import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import LineChart from "../charts/LineChart";
import employedSwitzerland from "../../data/employedSwitzerland";
import trendEmployeesSwitzerland from "../../data/trendEmployeesSwitzerland";
import trendNeedEmployees from "../../data/trendNeedEmployees";
import trendAvailabilityEmployees from "../../data/trendAvailabilityEmployees";


const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-6/12 flex-shrink-0 relative`;
const Image = styled.img(props => [
    props.imageRounded && tw`rounded`,
    props.imageBorder && tw`border`,
    props.imageShadow && tw`shadow`,
]);

const employedSwitzerlandData = {
    label: "Employed Switzerland",
    data: employedSwitzerland,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const trendEmployeesSwitzerlandData = {
    label: "Trend employees Switzerland",
    data: trendEmployeesSwitzerland,
    borderColor: 'rgb(182, 3, 252)',
    backgroundColor: 'rgba(182, 3, 252, 0.5)',
    borderDash: [10,5]
};

const trendNeedEmployeesData = {
    label: "Trend need employees",
    data: trendNeedEmployees,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const trendAvailabilityEmployeesData = {
    label: "Trend availability employees",
    data: trendAvailabilityEmployees,
    borderColor: 'rgb(182, 3, 252)',
    backgroundColor: 'rgba(182, 3, 252, 0.5)',
    borderDash: [10,5]
}

export default ({
                    title = "",
                    d1 = "",
                    d2 = "",
                    d3 = "",
                    image1="",
                    image2="",
                    image3 = "",
                }) => {
    const styles={border: '1px solid black',borderCollapse: 'collapse'}
    return (
        <>
            <h1>{title}</h1>
            <p>
                {d1}
            </p>
            <div  style={{textAlign:'center',margin:'3% 0% 3% 0%'}}>
                <ImageColumn style={{marginLeft:'auto',marginRight:'auto'}}>
                    <LineChart
                        data={[employedSwitzerlandData, trendEmployeesSwitzerlandData]}
                        title="Developement of employees in Switzerland 2015 - 2020"
                    />
                    <p>
                        {image1}
                    </p>
                </ImageColumn>
            </div>
            <div  style={{textAlign:'center',margin:'3% 0% 3% 0%'}}>
                <ImageColumn style={{marginLeft:'auto',marginRight:'auto'}}>
                    <LineChart
                        data={[trendNeedEmployeesData, trendAvailabilityEmployeesData]}
                        title="Employment trend in Switzerland 2020 - 2035"
                    />
                    <p>
                        {image2}
                    </p>
                </ImageColumn>
            </div>
            <p>
                {d2}
            </p>
            <div  style={{textAlign:'center',margin:'3% 0% 3% 0%'}}>
                <ImageColumn style={{marginLeft:'auto',marginRight:'auto'}}>
                    <strong>Forecasts skills shortage high to very high 2025</strong>
                    <table>
                        <tr style={styles}>
                            <th style={styles}>Branch</th>
                            <th style={styles}>Basic education</th>
                            <th style={styles}>Advanced training</th>
                            <th style={styles}>Employees</th>
                        </tr>
                        <tbody style={styles}>
                            <tr style={styles}>
                                <td style={styles}>Construction industry</td>
                                <td style={styles}>35</td>
                                <td style={styles}>44</td>
                                <td style={styles}>333'240</td>
                            </tr>
                            <tr style={styles}>
                                <td style={styles}>Healthcare</td>
                                <td style={styles}>8</td>
                                <td style={styles}>12</td>
                                <td style={styles}>312'347</td>
                            </tr>
                            <tr style={styles}>
                                <td style={styles}>Retail trade</td>
                                <td style={styles}>27</td>
                                <td style={styles}>3</td>
                                <td style={styles}>231'206</td>
                            </tr>
                            <tr style={styles}>
                                <td style={styles}>Banks and insurance</td>
                                <td style={styles}></td>
                                <td style={styles}>1</td>
                                <td style={styles}>210'134</td>
                            </tr>
                            <tr style={styles}>
                                <td style={styles}>Industry</td>
                                <td style={styles}>17</td>
                                <td style={styles}>5</td>
                                <td style={styles}>208'461</td>
                            </tr>
                            <tr style={styles}>
                                <td style={styles}>Logistics</td>
                                <td style={styles}>3</td>
                                <td style={styles}>5</td>
                                <td style={styles}>208'277</td>
                            </tr>
                            <tr style={styles}>
                                <td style={styles}>Hospitality</td>
                                <td style={styles}>4</td>
                                <td style={styles}>8</td>
                                <td style={styles}>178'650</td>
                            </tr>
                            <tr style={styles}>
                                <td style={styles}>Public adminstration</td>
                                <td style={styles}>1</td>
                                <td style={styles}></td>
                                <td style={styles}>171'332</td>
                            </tr>
                            <tr style={styles}>
                                <td style={styles}>Agriculture</td>
                                <td style={styles} >7</td>
                                <td style={styles}>2</td>
                                <td style={styles}>150'000</td>
                            </tr>
                            <tr style={styles}>
                                <td style={styles}>ICT*</td>
                                <td style={styles}>2</td>
                                <td style={styles}>7</td>
                                <td style={styles}>134'178</td>
                            </tr>
                            <tr style={styles}>
                                <td style={styles}>Automotive industry</td>
                                <td style={styles}>7</td>
                                <td style={styles}>6</td>
                                <td style={styles}>81'550</td>
                            </tr>
                            <tr style={styles}>
                                <td style={styles}>Food</td>
                                <td style={styles}>5</td>
                                <td style={styles}>10</td>
                                <td style={styles}>77'424</td>
                            </tr>
                            <tr style={styles}>
                                <td style={styles}>Chemistry, pharmaceuticals, laboratories</td>
                                <td style={styles}>3</td>
                                <td style={styles}>2</td>
                                <td style={styles}>73'117</td>
                            </tr>
                            <tr style={styles}>
                                <td style={styles}>Legal system</td>
                                <td style={styles}>1</td>
                                <td style={styles}></td>
                                <td style={styles}>69'010</td>
                            </tr>
                            <tr style={styles}>
                                <td style={styles}>Power supply</td>
                                <td style={styles}>1</td>
                                <td style={styles}>3</td>
                                <td style={styles}>27'421</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>121</td>
                                <td>108</td>
                                <td>2'322'497</td>
                            </tr>
                        </tbody>
                    </table>
                    <strong>ICT*:as a cross-sector occupation, the shortage affects the whole economy</strong>
                    <p>
                        {image3}
                    </p>
                </ImageColumn>
            </div>
            <p>
                {d3}
            </p>
        </>
    );
};
